import { render, staticRenderFns } from "./DialogoLista.vue?vue&type=template&id=78586696&"
import script from "./DialogoLista.vue?vue&type=script&lang=js&"
export * from "./DialogoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports